/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 12:21:22
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-18 17:09:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/TitlePart/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Input, Checkbox, Radio, Button } from '@/src/components/Antd';
import SectionContent from 'src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/SectionWrapper';
import Row from '@/src/components/Layouts/Row/Row';
import { EnumServiceType } from 'src/types/common/product';
import { EnumIds } from 'src/pages/ProductEditor/VirtualProduct/common';
import { getError } from 'src/tools/helper';
import CountWords from '@/src/components/CountWords/CountWords';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Title = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const defaultModalConfig = {
    modalOnOk: (e: React.MouseEvent) => {
      return;
    },
    modalOkText: getI18n('general.remove'),
    modalOnCancel: (e: React.MouseEvent) => {
      return;
    },
    modalOnCancelText: getI18n('general.cancel'),
    modalTitle: getI18n('Remove this detail item'),
    modalContent: getI18n(
      'allProducts.addvirtualproduct.productdetail_component_titlepart_modalContent',
    ),
  };
  const [modalConfig, setModalConfig] = React.useState({
    ...defaultModalConfig,
  });
  const [warningVisible, setWarningVisible] = React.useState(false);
  const {
    modalOnOk,
    modalOkText,
    modalOnCancel,
    modalOnCancelText,
    modalTitle,
    modalContent,
  } = modalConfig || {};
  const {
    id,
    data,
    onRequiredChange,
    onFieldTypeChange,
    onTitleChange,
    onDelete,
    disabled,
  } = props;
  const btnId = `${id}deleteBtn`;
  const { required, fieldType, title } = data;
  const handleOnFieldTypeChange = (e) => {
    const v = e.target.value;
    if (onFieldTypeChange) onFieldTypeChange(v);
  };

  return (
    <SectionContent hasBottomBorder>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                id={`${EnumIds.productDetailTitle}${id}`}
                title={`${getI18n('general.title')}*`}
                rightPart={
                  <CountWords count={(title || '').length} allCount={50} />
                }
                belowComponentTitle={
                  <Checkbox
                    onChange={onRequiredChange}
                    checked={required}
                    disabled={disabled}>
                    {getI18n(
                      'allProducts.addvirtualproduct.productdetail_component_titlepart_belowComponentTitle',
                    )}
                  </Checkbox>
                }>
                <Input
                  size='large'
                  error={getError('title', data)}
                  value={title}
                  onChange={onTitleChange}
                  maxLength={50}
                  disabled={disabled}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <div className={css.container}>
                <ItemWrapper
                  title={getI18n('allProducts.addvirtualproduct.fieldtype')}>
                  <Radio
                    className={css.radioGroup}
                    onChange={handleOnFieldTypeChange}
                    value={fieldType}
                    disabled={disabled}
                    radioList={[
                      {
                        label: getI18n(
                          'allProducts.addvirtualproduct.productdetail_component_titlepart_input_field',
                        ),
                        value: EnumServiceType.Text,
                        className: css.radio,
                      },
                      {
                        label: getI18n(
                          'allProducts.addvirtualproduct.productdetail_component_titlepart_Selector',
                        ),
                        value: EnumServiceType.Selector,
                      },
                    ]}
                  />
                </ItemWrapper>
                {onDelete && (
                  <WarningPopReminder
                    id={btnId}
                    visibilityOption={{
                      controlledByParent: true,
                      controlledVisible: warningVisible,
                      setControlledVisible: setWarningVisible,
                    }}
                    title={modalTitle}
                    content={modalContent}
                    onCancelText={modalOnCancelText}
                    onCancel={modalOnCancel}
                    onOkText={modalOkText}
                    onOk={modalOnOk}>
                    <Button
                      disabled={disabled}
                      id={btnId}
                      className={css.btn}
                      onClick={() => {
                        setWarningVisible(true);
                        //setDropVisible(false);
                        setModalConfig({
                          modalOnOk: (e) => {
                            if (onDelete) onDelete();
                            setWarningVisible(false);
                            return;
                          },
                          modalOkText: modalOkText,
                          modalOnCancel: (e) => {
                            if (modalOnCancel) modalOnCancel(e);
                            setWarningVisible(false);
                            return;
                          },
                          modalOnCancelText: getI18n('general.cancel'),
                          modalTitle: modalTitle,
                          modalContent: modalContent,
                        });
                      }}>
                      {getI18n('general.remove')}
                    </Button>
                  </WarningPopReminder>
                )}
              </div>
            ),
          },
        ]}
      />
    </SectionContent>
  );
};
export default Title;
